export default __webpack_public_path__ + "static/media/andrew_b.72be0429.png";